import { Outlet, useNavigate } from 'react-router-dom';
import { AppLayout } from '@heroui-pro/react';
import { AppNavbar } from './app-navbar';
import { AppSidebar } from './app-sidebar';

/**
 * HeroUI Pro 应用外壳（对应 template-finances 的 AppLayout 组合）。
 * sidebar：左侧栏；navbar：主区顶栏；children：主区内容。
 */
export function AppShell() {
  const navigate = useNavigate();

  return (
    <AppLayout
      navigate={(href) => {
        navigate(href);
      }}
      navbar={<AppNavbar />}
      sidebar={<AppSidebar />}
      sidebarCollapsible="icon"
    >
      {/*
        AppLayout 把 children 放进 <main class="app-layout__main">（flex:1 + min-w-0，自身不是 flex 容器）。
        这里不能用 flex-1：在块级 main 下无效，主区高度会塌成内容高，子页面里 flex-1 中间区永远不撑开。
        用 h-full 占满 main 已算出的高度，再向下传 min-h-0 + flex 列。
      */}
      <div className="flex h-full min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden bg-background">
        <Outlet />
      </div>
    </AppLayout>
  );
}
